import { render } from "./arAccountModel.vue?vue&type=template&id=62db7bc7"
import script from "./arAccountModel.vue?vue&type=script&lang=js"
export * from "./arAccountModel.vue?vue&type=script&lang=js"

import "./arAccountModel.vue?vue&type=style&index=0&id=62db7bc7&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__